/**
 * In ECMA-262 Object.values and Object.entries was specified. Some of the
 * browsers we support does not implement this specification. Therefore we
 * define these functions here if they are missing.
 *
 * The code is based on the polyfill referenced by developer.mozilla.com.
 * You can find that here: https://github.com/tc39/proposal-object-values-entries.
 */

const reduce = Function.bind.call(Function.call, Array.prototype.reduce);
const isEnumerable = Function.bind.call(Function.call, Object.prototype.propertyIsEnumerable);
const concat = Function.bind.call(Function.call, Array.prototype.concat);
const keys = Reflect.ownKeys;

if (!Object.values) {
  Object.values = function values(O) {
    return reduce(
      keys(O),
      (v, k) => concat(v, typeof k === 'string' && isEnumerable(O, k) ? [O[k]] : []),
      [],
    );
  };
}

if (!Object.entries) {
  Object.entries = function entries(O) {
    return reduce(
      keys(O),
      (e, k) => concat(e, typeof k === 'string' && isEnumerable(O, k) ? [[k, O[k]]] : []),
      [],
    );
  };
}

if (!Object.fromEntries) {
  Object.fromEntries = function fromEntries(arr) {
    return reduce(arr, (acc, [key, value]) => Object.assign(acc, { [key]: value }), {});
  };
}
